import React, { FunctionComponent, SVGProps } from 'react';
import styled, { useTheme } from 'styled-components';

interface AddIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  circleColor?: string;
  pathColor?: string;
  size?: number;
}

const AddIcon: FunctionComponent<AddIconProps> = ({
  className,
  circleColor,
  pathColor,
  ...props
}) => {
  const theme = useTheme();
  return (
    <svg viewBox="0 0 32 32" className={className || ''} {...props}>
      <path
        fill={circleColor ? circleColor : theme.colors.accent}
        d="M32,16C32,7.16,24.84,0,16,0S0,7.16,0,16s7.16,16,16,16,16-7.16,16-16Z"
      />
      <path
        fill={pathColor ? pathColor : theme.colors.white}
        d="M20.38,15h-3.38v-3.38c0-.35-.45-.62-1-.62s-1,.28-1,.62v3.38h-3.38c-.35,0-.62,.45-.62,1s.28,1,.62,1h3.38v3.38c0,.35,.45,.62,1,.62s1-.28,1-.62v-3.38h3.38c.35,0,.62-.45,.62-1s-.28-1-.62-1Z"
      />
    </svg>
  );
};

export default styled(AddIcon)`
  width: ${(props) => (props.size ? `${props.size}px` : '32px')};
  height: ${(props) => (props.size ? `${props.size}px` : '32px')};
`;
